window.BXDEBUG = true;
$(document).ready(function () {
    // слайдер Swiper
    const collectSetSlider = new Swiper('.collectSetSlider', {
        // Optional parameters
        slidesPerView: "auto",

        // Navigation arrows
        navigation: {
            nextEl: '.collectSet__sliderWrap .swiper-button-next',
            prevEl: '.collectSet__sliderWrap .swiper-button-prev',
        }
    });
});


// при нажатии "Купить комплект" товары попадают в корзину и кнопка меняется на "Перейти в корзину"
// log c массивом data-id выделенных товаров и + текущий
$(document).ready(function () {
    if( $('.popup .offer-list-item').length > 0 ) {
        $('#collectSet__btnBuy').attr('disabled', 'disabled');
    }

    $(document).on('click', '.offer-list-item', function(){
       var offer_id = $('#collect .popup .offer-list-item[title="' + $(this).attr('title') + '"]').attr('data-onevalue');

        $('#collectSet .collectSetSlider').attr('data-id-product', offer_id);

        $('#collectSet form .collectSet__btnBuy').remove();
        $('#collectSet form.collectSet__form').append('<button id="collectSet__btnBuy2" data-auto-focus="false" class="collectSet__btnBuy">Купить комплект</button>');
        $(this).parents('.collectSetPopup__row').find('.offer-list-item').removeClass('selected');
        $(this).addClass('selected');
        $(this).parents('.collectSetPopup__row').find('input.lk-form-checkbox').attr('data-id-collect', $(this).data('onevalue'));
        if($('.popup .offer-list-item.selected').length === $('.popup .cat-element-offer-list').length) {
            $('#collectSet__btnBuy').removeAttr('disabled');
        } else {
            $('#collectSet__btnBuy').attr('disabled', 'disabled');
        }
    });

    //if ($('#collectSet__btnBuy').length > 0) {
        $(document).on('click', '#collectSet__btnBuy, #collectSet__btnBuy2', function (e) {
            var btn = $(this);
            e.preventDefault();

            if ($(this).hasClass('added') == false) {
                // слайдер с товарами в комплекте
                let collectSetSlider = $('#collect .popup .collectSet__form');

                // чекбоксы товаров из комплекта
                let collection_chekboxes = collectSetSlider.find('.collectSetPopup__row input');

                // пустой массив, в который соберутся ID всех товаров в комплекте, включая текущий
                let collection_IDs_Array = [];


                if ($(this).attr('id') == 'collectSet__btnBuy2') {
                    let collectSetSlider = $(this).siblings('.collectSet__sliderWrap').find('.collectSetSlider');

                    collection_chekboxes = collectSetSlider.find('input.lk-form-checkbox');

                    // ID текущего товара (к которому подбирается комплект)
                    let currentProduct_ID = collectSetSlider.attr('data-id-product');
                    // добавляем ID текущего товара в массив
                    collection_IDs_Array.push(currentProduct_ID);
                }

                // перебор чекбоксов товаров
                collection_chekboxes.each(function (index, element) {

                    // ID чекбокса товара
                    let collectionProduct_ID = $(element).attr('data-id-collect');

                    // проверка выбран ли товар
                    let collectSetSliderItem_checked = $(element).is(":checked");

                    // добавляем в итоговый массив, если товар выбран
                    if (collectSetSliderItem_checked) {
                        collection_IDs_Array.push(collectionProduct_ID);
                    }
                });

                btn.attr('disabled', 'disabled');

                // вывод в консоль массива ID выбранных товаров из комплекта
                BX.ajax.loadJSON(
                    '/ajax/addCollection.php',
                    {productsIds: collection_IDs_Array},
                    _onSuccess
                );
                BX.addCustomEvent( 'onAjaxSuccess' ,   function  (data) {

                });

            } else {
                window.location.href = '/cart/';
            }
        });
    //}
});

function _onSuccess(data) {
    var btn = $('#collectSet__btnBuy');
    if(data.STATUS == 'ERROR'){
        $('#collect .popup-article').html(data.MESSAGE);
    }

    btn.html('Перейти в корзину');
    btn.addClass('added');

    btn.removeAttr('disabled')

    BX.onCustomEvent('OnBasketChange');

    $('.setOfWeek__addToCartBtn').text('В корзине');
    
}